module.exports = __webpack_public_path__ + "01_glasses.050aa156.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/kanai/male/layer4/01_glasses.png
// module id = nYVf
// module chunks = 0